import { removeDraft } from "@/offline/db";
import { withDraftDb } from "@/offline/draftDb";
import { deleteDB } from "idb";

export const LEGACY_CACHE_DB_NAME = "crm-pwa-cache";

const LEGACY_DRAFT_IDS = ["current", "quick"];

const LEGACY_STORAGE_KEYS = ["maqia.crm.push.offer"];

const LEGACY_STORAGE_PREFIXES = ["maqia.crm.push.declined:"];

export type LegacyCleanupStep = () => Promise<void> | void;

export const LEGACY_CLEANUP_STEPS: readonly LegacyCleanupStep[] = [
  unsubscribeFromPush,
  () => deleteDB(LEGACY_CACHE_DB_NAME),
  removeLegacyDrafts,
  removeLegacyStorage,
];

export async function cleanUpLegacyInstall(
  steps: readonly LegacyCleanupStep[] = LEGACY_CLEANUP_STEPS,
): Promise<void> {
  await Promise.allSettled(steps.map((step) => Promise.resolve().then(step)));
}

async function unsubscribeFromPush(): Promise<void> {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  const registration = await navigator.serviceWorker.getRegistration();
  if (registration === undefined || !("pushManager" in registration)) {
    return;
  }
  const subscription = await registration.pushManager.getSubscription();
  if (subscription !== null) {
    await subscription.unsubscribe();
  }
}

function removeLegacyDrafts(): Promise<void> {
  return withDraftDb(async (opened) => {
    for (const id of LEGACY_DRAFT_IDS) {
      await removeDraft(opened, id);
    }
  });
}

function removeLegacyStorage(): void {
  const stale: string[] = [];
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (
      key !== null &&
      (LEGACY_STORAGE_KEYS.includes(key) ||
        LEGACY_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix)))
    ) {
      stale.push(key);
    }
  }
  for (const key of stale) {
    localStorage.removeItem(key);
  }
}
